import React from 'react';
import './css/quickbardetail.css';
import cookie from 'react-cookies';
import riyongping from '../../assets/QQPenguin_gg/riyongping.png';
import diamond from '../../assets/QQPenguin_gg/diamond.png';
import jinyuanbao from '../../assets/QQPenguin_gg/yuanbao.png';
import pengshiqi from '../../assets/QQPenguin_gg/pengshiqi.png';
import baobaojinshui from '../../assets/QQPenguin_gg/baobaojinshui.png';
import icecream from '../../assets/QQPenguin_gg/icecream.png';
import mooncake from '../../assets/QQPenguin_gg/mooncake.png';
import zhuangtou from '../../assets/QQPenguin_gg/work/1/2.gif';
import wagong from '../../assets/QQPenguin_gg/work/1/4.gif';
import huanhundan from '../../assets/QQPenguin_gg/huanhundan.png';
import baicaodan from '../../assets/QQPenguin_gg/baicaodan.png';
import xiaoxue_laoji from '../../assets/QQPenguin_gg/xiaoxue_laoji.png';
import xiaoxue_tiyu from '../../assets/QQPenguin_gg/xiaoxue_tiyu.png';

class QuickbarDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { menu: [1, 0], item: [1, 0], num1: 1, num2: 1 };
  }
  componentDidMount() {
    this.setState({ num1: 1, num2: 1 });
  }
  buy = e => {
    e.preventDefault();
    this.setState({ menu: [0, 1] });
  };

  chooseitem1 = () => {
    this.setState({ item: [1, 0] });
  };

  chooseitem2 = () => {
    this.setState({ item: [0, 1] });
  };

  feed = () => {
    this.props.feed();
    this.props.shut();
    const hungery = parseInt(cookie.load('hungery'));
    let inFifteenMinutes = new Date(
      new Date().getTime() + 7 * 24 * 3600 * 1000,
    ); //一周
    if (!!this.state.item[0])
      cookie.save('hungery', hungery + 90 < 800 ? hungery + 90 : 800, {
        path: '/',
        expires: inFifteenMinutes,
      });
    else
      cookie.save('hungery', hungery + 180 < 800 ? hungery + 180 : 800, {
        path: '/',
        expires: inFifteenMinutes,
      });
  };

  medicine = () => {
    this.props.medicine();
    this.props.shut();
  };

  work = () => {
    clearInterval(global.pet.Interval3);
    this.props.work1();
    this.props.shutwork();
    let inFifteenMinutes = new Date(
      new Date().getTime() + 7 * 24 * 3600 * 1000,
    ); //一周
    cookie.save('now', '工作中', { path: '/', expires: inFifteenMinutes });
    global.pet.Interval3 = setInterval(
      () => {
        this.normal();
        let inFifteenMinutes = new Date(
          new Date().getTime() + 7 * 24 * 3600 * 1000,
        ); //一周
        cookie.save('now', '成长中', { path: '/', expires: inFifteenMinutes });
      },
      !!this.state.item[0] ? 1000 * 60 * 30 : 1000 * 60 * 60,
    );
  };
  normal = () => {
    this.props.normal();
  };
  study = () => {
    clearInterval(global.pet.Interval3);
    this.props.study1();
    this.props.shutwork();
    let inFifteenMinutes = new Date(
      new Date().getTime() + 7 * 24 * 3600 * 1000,
    ); //一周
    cookie.save('now', '学习中', { path: '/', expires: inFifteenMinutes });
    global.pet.Interval3 = setInterval(
      () => {
        this.normal();
        let inFifteenMinutes = new Date(
          new Date().getTime() + 7 * 24 * 3600 * 1000,
        ); //一周
        cookie.save('now', '成长中', { path: '/', expires: inFifteenMinutes });
      },
      !!this.state.item[0] ? 1000 * 60 * 30 : 1000 * 60 * 45,
    );
  };

  shower = () => {
    this.props.shower();
    this.props.shut();
    const clean = parseInt(cookie.load('clean'));
    let inFifteenMinutes = new Date(
      new Date().getTime() + 7 * 24 * 3600 * 1000,
    ); //一周
    if (this.state.item[0])
      cookie.save('clean', clean + 360 < 1000 ? clean + 360 : 1000, {
        path: '/',
        expires: inFifteenMinutes,
      });
    else
      cookie.save('clean', clean + 540 < 1000 ? clean + 540 : 1000, {
        path: '/',
        expires: inFifteenMinutes,
      });
  };

  changeEvent1 = e => {
    let value = e.target.value.replace(/[^\d]/, '');
    if (value === '') value = 1;
    this.setState({ num1: value });
  };

  changeEvent2 = e => {
    let value = e.target.value.replace(/[^\d]/, '');
    if (value === '') value = 1;
    this.setState({ num2: value });
  };

  leftArrow1 = () => {
    this.setState({ item: [1, 0] });
    if (this.state.num1 < 99) this.setState({ num1: this.state.num1 + 1 });
  };

  leftArrow2 = () => {
    this.setState({ item: [0, 1] });
    if (this.state.num2 < 99) this.setState({ num2: this.state.num2 + 1 });
  };

  rightArrow1 = () => {
    this.setState({ item: [1, 0] });
    if (this.state.num1 > 1) this.setState({ num1: this.state.num1 - 1 });
  };

  rightArrow2 = () => {
    this.setState({ item: [0, 1] });
    if (this.state.num2 > 1) this.setState({ num2: this.state.num2 - 1 });
  };

  render() {
    return (
      <div>
        {this.state.menu[0] && !(this.props.work || this.props.study) ? (
          <div
            className="detailmenu1"
            style={{
              transform: `translate(calc(100vw - 380px + ${this.props.x}px),calc(100vh - 300px + ${this.props.y}px))`,
            }}
          >
            <div className="title">请选择物品并单击使用:</div>
            <div className="right-title-btn" onClick={this.props.shut}></div>
            <div className="itemlist">
              <div className="itemLeft"></div>
              <img src={riyongping}></img>
              <div className="item">
                储藏室中没有{this.props.type},请
                <a href="#" onClick={this.buy}>
                  购买
                </a>
                。
              </div>
              <div className="itemRight"></div>
            </div>
            <div className="footer">
              <img src={diamond}></img>
              <div>
                <a href="#">开通粉钻</a>,体现尊贵专属特权。
              </div>
              <div></div>
            </div>
          </div>
        ) : null}
        {this.state.menu[1] && this.props.type === '日用品' ? (
          <div
            className="detailmenu2"
            style={{
              transform: `translate(calc(100vw - 380px + ${this.props.x}px),calc(100vh - 300px + ${this.props.y}px))`,
            }}
          >
            <div className="title">
              您的储藏室里还没有{this.props.type}哦,请先购买些{this.props.type}。
            </div>
            <div className="right-title-btn" onClick={this.props.shut}></div>
            <div className="choosItem">请选择您要购买的物品:</div>
            <button
              className="shopping"
              onClick={() => alert(`很遗憾〒▽〒，作者没有相关素材！`)}
            >
              &nbsp;去商城购买&nbsp;
            </button>
            <br />
            <div
              className="item1"
              style={{
                border: this.state.item[0] ? `2px solid` : null,
                borderColor: this.state.item[0] ? `rgb(52, 220, 225)` : null,
                boxShadow: this.state.item[0]
                  ? `2px 2px 5px rgb(52, 220, 225)`
                  : null,
              }}
            >
              <img src={pengshiqi} onClick={this.chooseitem1}></img>
              <div className="detail">
                舒爽喷湿器
                <br />
                清洁值:+360
                <br />
                元宝: 10
              </div>
              <div className="num">
                购买数量:
                <div className="numRight" onClick={this.leftArrow1}></div>
                <input
                  value={this.state.num1}
                  onChange={this.changeEvent1}
                ></input>
                <div className="numLeft" onClick={this.rightArrow1}></div>
              </div>
            </div>
            <div
              className="item2"
              style={{
                border: this.state.item[1] ? `2px solid` : null,
                borderColor: this.state.item[1] ? `rgb(52, 220, 225)` : null,
                boxShadow: this.state.item[1]
                  ? `2px 2px 5px rgb(52, 220, 225)`
                  : null,
              }}
            >
              <img src={baobaojinshui} onClick={this.chooseitem2}></img>
              <div className="detail">
                宝宝金水
                <br />
                清洁值:+540
                <br />
                元宝: 15
              </div>
              <div className="num">
                购买数量:
                <div className="numRight" onClick={this.leftArrow2}></div>
                <input
                  value={this.state.num2}
                  onChange={this.changeEvent2}
                ></input>
                <div className="numLeft" onClick={this.rightArrow2}></div>
              </div>
            </div>
            <div className="choosItem">请选择支付方式</div>
            <br />
            <div className="choosPay">
              <label>
                <input
                  name="pay"
                  type="radio"
                  value="1"
                  defaultChecked={true}
                />
                元宝支付
              </label>
              <label>
                <input name="pay" type="radio" value="2" />
                Q币支付
              </label>
              <label>
                <input name="pay" type="radio" value="3" />
                Q点支付
              </label>
              <label>
                <input name="pay" type="radio" value="4" />
                他人支付
              </label>
            </div>
            <div className="virtualLine"></div>
            <div className="yuanbao">
              <img src={jinyuanbao}></img>
              250
            </div>
            <button className="pay" onClick={this.shower}>&nbsp;&nbsp;确认支付&nbsp;&nbsp;</button>
          </div>
        ) : null}
        {this.state.menu[1] && this.props.type === '食品' ? (
          <div
            className="detailmenu2"
            style={{
              transform: `translate(calc(100vw - 380px + ${this.props.x}px),calc(100vh - 300px + ${this.props.y}px))`,
            }}
          >
            <div className="title">
              您的储藏室里还没有{this.props.type}哦,请先购买些{this.props.type}。
            </div>
            <div className="right-title-btn" onClick={this.props.shut}></div>
            <div className="choosItem">请选择您要购买的物品:</div>
            <button
              className="shopping"
              onClick={() => alert(`很遗憾〒▽〒，作者没有相关素材！`)}
            >
              &nbsp;去商城购买&nbsp;
            </button>
            <br />
            <div
              className="item1"
              style={{
                border: this.state.item[0] ? `2px solid` : null,
                borderColor: this.state.item[0] ? `rgb(52, 220, 225)` : null,
                boxShadow: this.state.item[0]
                  ? `2px 2px 5px rgb(52, 220, 225)`
                  : null,
              }}
            >
              <img src={icecream} onClick={this.chooseitem1}></img>
              <div className="detail">
                圈圈冰激凌
                <br />
                饥饿值:+90
                <br />
                元宝: 5
              </div>
              <div className="num">
                购买数量:
                <div className="numRight" onClick={this.leftArrow1}></div>
                <input
                  value={this.state.num1}
                  onChange={this.changeEvent1}
                ></input>
                <div className="numLeft" onClick={this.rightArrow1}></div>
              </div>
            </div>
            <div
              className="item2"
              style={{
                border: this.state.item[1] ? `2px solid` : null,
                borderColor: this.state.item[1] ? `rgb(52, 220, 225)` : null,
                boxShadow: this.state.item[1]
                  ? `2px 2px 5px rgb(52, 220, 225)`
                  : null,
              }}
            >
              <img src={mooncake} onClick={this.chooseitem2}></img>
              <div className="detail">
                月光饼饼
                <br />
                饥饿值:+180
                <br />
                元宝: 10
              </div>
              <div className="num">
                购买数量:
                <div className="numRight" onClick={this.leftArrow2}></div>
                <input
                  value={this.state.num2}
                  onChange={this.changeEvent2}
                ></input>
                <div className="numLeft" onClick={this.rightArrow2}></div>
              </div>
            </div>
            <div className="choosItem">请选择支付方式</div>
            <br />
            <div className="choosPay">
              <label>
                <input
                  name="pay"
                  type="radio"
                  value="1"
                  defaultChecked={true}
                />
                元宝支付
              </label>
              <label>
                <input name="pay" type="radio" value="2" />
                Q币支付
              </label>
              <label>
                <input name="pay" type="radio" value="3" />
                Q点支付
              </label>
              <label>
                <input name="pay" type="radio" value="4" />
                他人支付
              </label>
            </div>
            <div className="virtualLine"></div>
            <div className="yuanbao">
              <img src={jinyuanbao}></img>
              250
            </div>
            <button className="pay" onClick={this.feed}>&nbsp;&nbsp;确认支付&nbsp;&nbsp;</button>
          </div>
        ) : null}
        {this.state.menu[1] && this.props.type === '药品' ? (
          <div
            className="detailmenu2"
            style={{
              transform: `translate(calc(100vw - 380px + ${this.props.x}px),calc(100vh - 300px + ${this.props.y}px))`,
            }}
          >
            <div className="title">
              您的储藏室里还没有{this.props.type}哦,请先购买些{this.props.type}。
            </div>
            <div className="right-title-btn" onClick={this.props.shut}></div>
            <div className="choosItem">请选择您要购买的物品:</div>
            <button
              className="shopping"
              onClick={() => alert(`很遗憾〒▽〒，作者没有相关素材！`)}
            >
              &nbsp;去商城购买&nbsp;
            </button>
            <br />
            <div
              className="item1"
              style={{
                border: this.state.item[0] ? `2px solid` : null,
                borderColor: this.state.item[0] ? `rgb(52, 220, 225)` : null,
                boxShadow: this.state.item[0]
                  ? `2px 2px 5px rgb(52, 220, 225)`
                  : null,
              }}
            >
              <img src={huanhundan} onClick={this.chooseitem1}></img>
              <div className="detail">
                还魂丹 (传说
                <br />
                能够起死回生)
                <br />
                元宝: 400
              </div>
              <div className="num">
                购买数量:
                <div className="numRight" onClick={this.leftArrow1}></div>
                <input
                  value={this.state.num1}
                  onChange={this.changeEvent1}
                ></input>
                <div className="numLeft" onClick={this.rightArrow1}></div>
              </div>
            </div>
            <div
              className="item2"
              style={{
                border: this.state.item[1] ? `2px solid` : null,
                borderColor: this.state.item[1] ? `rgb(52, 220, 225)` : null,
                boxShadow: this.state.item[1]
                  ? `2px 2px 5px rgb(52, 220, 225)`
                  : null,
              }}
            >
              <img src={baicaodan} onClick={this.chooseitem2}></img>
              <div className="detail">
                百草丹 (传说
                <br />
                能够治百病)
                <br />
                元宝: 240
              </div>
              <div className="num">
                购买数量:
                <div className="numRight" onClick={this.leftArrow2}></div>
                <input
                  value={this.state.num2}
                  onChange={this.changeEvent2}
                ></input>
                <div className="numLeft" onClick={this.rightArrow2}></div>
              </div>
            </div>
            <div className="choosItem">请选择支付方式</div>
            <br />
            <div className="choosPay">
              <label>
                <input
                  name="pay"
                  type="radio"
                  value="1"
                  defaultChecked={true}
                />
                元宝支付
              </label>
              <label>
                <input name="pay" type="radio" value="2" />
                Q币支付
              </label>
              <label>
                <input name="pay" type="radio" value="3" />
                Q点支付
              </label>
              <label>
                <input name="pay" type="radio" value="4" />
                他人支付
              </label>
            </div>
            <div className="virtualLine"></div>
            <div className="yuanbao">
              <img src={jinyuanbao}></img>
              250
            </div>
            <button className="pay" onClick={this.medicine}>&nbsp;&nbsp;确认支付&nbsp;&nbsp;</button>
          </div>
        ) : null}
        {this.props.work ? (
          <div
            className="detailmenu3"
            style={{
              transform: `translate(calc(100vw - 380px + ${this.props.x}px),calc(100vh - 300px + ${this.props.y}px))`,
            }}
          >
            <div
              className="right-title-btn"
              onClick={this.props.shutwork}
            ></div>
            <div className="title">
              暑假打工季,奖励三倍呢,快选择一个工种进行打工吧!
            </div>
            <div
              className="item1"
              style={{
                border: this.state.item[0] ? `2px solid` : null,
                borderColor: this.state.item[0] ? `rgb(52, 220, 225)` : null,
                boxShadow: this.state.item[0]
                  ? `2px 2px 5px rgb(52, 220, 225)`
                  : null,
              }}
            >
              <img src={zhuangtou} onClick={this.chooseitem1}></img>
              <div className="detail">
                搬砖头
                <br />
                +10*3元宝
              </div>
            </div>
            <div
              className="item2"
              style={{
                border: this.state.item[1] ? `2px solid` : null,
                borderColor: this.state.item[1] ? `rgb(52, 220, 225)` : null,
                boxShadow: this.state.item[1]
                  ? `2px 2px 5px rgb(52, 220, 225)`
                  : null,
              }}
            >
              <img src={wagong} onClick={this.chooseitem2}></img>
              <div className="detail">
                泥瓦工
                <br />
                +10*3元宝
              </div>
            </div>
            <div className="choosItem">
              请选择打工时间
              <br />
            </div>
            <div className="choosTime">
              <label>
                <input
                  name="pay"
                  type="radio"
                  value="1"
                  defaultChecked={true}
                />
                0.5小时
              </label>
              <label>
                <input name="pay" type="radio" value="2" />
                1小时
              </label>
            </div>
            <button className="work" onClick={this.work}>
              &nbsp;&nbsp;开始打工&nbsp;&nbsp;
            </button>
            <a
              href="#"
              onClick={() => alert(`很遗憾〒▽〒，作者没有相关素材！`)}
            >
              进入社区中打工场可以选择更多的工种
            </a>
          </div>
        ) : null}
        {this.props.study ? (
          <div
            className="detailmenu3"
            style={{
              height: `166px`,
              transform: `translate(calc(100vw - 380px + ${this.props.x}px),calc(100vh - 300px + ${this.props.y}px))`,
            }}
          >
            <div
              className="right-title-btn"
              onClick={this.props.shutwork}
            ></div>
            <div className="title">
              开学第一周又见熟悉的朋友笑脸，又见往日校园的花草!
            </div>
            <div
              className="item1"
              style={{
                marginTop: '10px',
                border: this.state.item[0] ? `2px solid` : null,
                borderColor: this.state.item[0] ? `rgb(52, 220, 225)` : null,
                boxShadow: this.state.item[0]
                  ? `2px 2px 5px rgb(52, 220, 225)`
                  : null,
              }}
            >
              <img src={xiaoxue_laoji} onClick={this.chooseitem1}></img>
              <div className="study_detail">
                小学劳技
                <br />
                剩余课时: 8节
                <br />
                武力值:+5
              </div>
            </div>
            <div
              className="item2"
              style={{
                marginTop: '10px',
                border: this.state.item[1] ? `2px solid` : null,
                borderColor: this.state.item[1] ? `rgb(52, 220, 225)` : null,
                boxShadow: this.state.item[1]
                  ? `2px 2px 5px rgb(52, 220, 225)`
                  : null,
              }}
            >
              <img src={xiaoxue_tiyu} onClick={this.chooseitem2}></img>
              <div className="study_detail">
                小学体育
                <br />
                剩余课时: 8节
                <br />
                武力值:+5
              </div>
            </div>
            <button
              className="work"
              style={{
                marginTop: '15px',
              }}
              onClick={this.study}
            >
              &nbsp;&nbsp;开始学习&nbsp;&nbsp;
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}
export default QuickbarDetail;
